import store from "@/store/store";
import { fetchData, ENDPOINT_HOST } from "./api_helper";

const apiURL = `${ENDPOINT_HOST}`;

const fetchTasks = (page, keyword = "", filter = "own", needAll, siteId) =>
  new Promise((resolve, reject) => {
    const partnerId = store.state.loggedInUser.partner_id;
    let endpointURL = `${apiURL}partners/${partnerId}/tasks?page=${page}&term=${keyword}&filter=${filter}`;
    if (needAll) {
      endpointURL = `${apiURL}partners/${partnerId}/tasks?need_all=true&term=${keyword}&site_id=${siteId}&page=${page}`;
    }
    fetchData(endpointURL, "get", null, resolve, reject).catch(error => {
      reject(error);
    });
  });

const fetchCalendarTasks = (keyword = "", siteId = undefined) =>
  new Promise((resolve, reject) => {
    const partnerId = store.state.loggedInUser.partner_id;
    let endpointURL = `${apiURL}partners/${partnerId}/calendar_tasks?&term=${keyword}`;
    if (siteId) {
      endpointURL = `${apiURL}partners/${partnerId}/calendar_tasks?&term=${keyword}&site_id=${siteId}`;
    }
    fetchData(endpointURL, "get", null, resolve, reject).catch(error => {
      reject(error);
    });
  });

const fetchTask = id =>
  new Promise((resolve, reject) => {
    const partnerId = store.state.loggedInUser.partner_id;
    const endpointURL = `${apiURL}partners/${partnerId}/tasks/${id}`;
    fetchData(endpointURL, "get", null, resolve, reject).catch(error => {
      reject(error);
    });
  });

const updateTask = params =>
  new Promise((resolve, reject) => {
    const partnerId = store.state.loggedInUser.partner_id;
    const endpointURL = `${apiURL}partners/${partnerId}/tasks/${params.id}?is_mobile=false`;
    const formData = new FormData();
    Object.keys(params).forEach(k => {
      if (
        params[k] !== undefined &&
        params[k] != null &&
        params[k] !== "null"
      ) {
        if (k === "files") {
          params[k].forEach(x => {
            formData.append("files[]", x, x.name);
          });
        } else if (k === "asset_ids") {
          params[k].forEach(x => {
            formData.append("asset_ids[]", x);
          });
        } else {
          formData.append(k, params[k]);
        }
      }
    });
    fetchData(endpointURL, "put", formData, resolve, reject).catch(error => {
      reject(error);
    });
  });

const updateTaskStatus = params =>
  new Promise((resolve, reject) => {
    const partnerId = store.state.loggedInUser.partner_id;
    const endpointURL = `${apiURL}partners/${partnerId}/tasks/${params.id}?is_mobile=true`;
    const formData = new FormData();
    Object.keys(params).forEach(k => {
      if (
        params[k] !== undefined &&
        params[k] != null &&
        params[k] !== "null"
      ) {
        if (k === "files") {
          params[k].forEach(x => {
            formData.append("files[]", x, x.name);
          });
        } else if (k === "asset_ids") {
          params[k].forEach(x => {
            formData.append("asset_ids[]", x);
          });
        } else {
          formData.append(k, params[k]);
        }
      }
    });
    fetchData(endpointURL, "put", formData, resolve, reject).catch(error => {
      reject(error);
    });
  });

const createTask = (params, siteId) =>
  new Promise((resolve, reject) => {
    const partnerId = store.state.loggedInUser.partner_id;
    const endpointURL = `${apiURL}partners/${partnerId}/tasks?site_id=${siteId}`;
    console.log(params);
    const formData = new FormData();
    Object.keys(params).forEach(k => {
      if (
        params[k] !== undefined &&
        params[k] != null &&
        params[k] !== "null"
      ) {
        if (k === "files") {
          params[k].forEach(x => {
            formData.append("files[]", x, x.name);
          });
        } else {
          formData.append(k, params[k]);
        }
      }
    });
    fetchData(endpointURL, "post", formData, resolve, reject).catch(error => {
      reject(error);
    });
  });

const deleteTask = id =>
  new Promise((resolve, reject) => {
    const partnerId = store.state.loggedInUser.partner_id;
    const endpointURL = `${apiURL}partners/${partnerId}/tasks/${id}`;
    fetchData(endpointURL, "delete", null, resolve, reject).catch(error => {
      reject(error);
    });
  });

const sendMessage = params =>
  new Promise((resolve, reject) => {
    const partnerId = store.state.loggedInUser.partner_id;
    const endpointURL = `${apiURL}partners/${partnerId}/tasks/${params.id}/task_messages`;
    fetchData(endpointURL, "post", params, resolve, reject).catch(error => {
      reject(error);
    });
  });

export default {
  fetchTasks,
  fetchTask,
  updateTask,
  updateTaskStatus,
  createTask,
  deleteTask,
  sendMessage,
  fetchCalendarTasks
};



// WEBPACK FOOTER //
// ./src/api/tasks.js